/* -----------------------------------------------------------------
   JAC'D UP CUSTOM - keep the thumbnail highlight on the open image.

   Companion to the lead-image change in
   snippets/product-media-gallery.liquid (2026-09-18), and only
   needed because of it.

   The gallery now opens on the product's first media - the lifestyle
   photo - rather than on the selected variant's mockup. Craft renders
   that lead thumbnail with aria-current="true" baked into the markup,
   which is correct on load.

   It stops being correct the moment someone taps a colour. Craft's
   product-info.js fetches the section again for the new variant and
   swaps the markup in, and that markup still carries the baked-in
   aria-current on the lifestyle thumbnail. The big image moves to the
   chosen colourway; the copper outline stays behind on the lifestyle
   shot. Small, but it is exactly the kind of mismatch that reads as
   broken.

   Rather than race Craft, this restates the one invariant that
   matters: the outlined thumbnail is the slide that is open. It is
   idempotent, so it settles rather than fights.

   WHY THE OBSERVER IS ON <body> AND NOT ON THE GALLERY. Version 1
   observed the media-gallery element itself and did nothing at all,
   because the variant re-render REPLACES that element - the observer
   was left watching a node no longer in the document. body survives.
   The `change` listener alone is not enough either: it fires on the
   click, while the swap happens a fetch later.

   attributeFilter is `class`, which is what Craft toggles for
   is-active. aria-current is not in the filter, so writing it cannot
   retrigger the observer.

   Retire this WITH the lead-image change, not before - the two are
   one feature. It is independent of jacdup-gallery-note.js.
   ----------------------------------------------------------------- */
(function () {
  'use strict';

  function sync() {
    var root = document.querySelector('.product__media-wrapper media-gallery');
    if (!root) return;

    var active = root.querySelector('.product__media-item.is-active');
    if (!active) return;

    var target = active.getAttribute('data-media-id');
    if (!target) return;

    var wanted = root.querySelector('.thumbnail-list__item[data-target="' + target + '"] button');
    if (!wanted || wanted.getAttribute('aria-current') === 'true') return;

    root.querySelectorAll('.thumbnail-list__item button').forEach(function (b) {
      b.removeAttribute('aria-current');
    });
    wanted.setAttribute('aria-current', 'true');
  }

  var pending;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(sync, 80);
  }

  function start() {
    if (!document.querySelector('.product__media-wrapper media-gallery')) return;

    sync();

    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    /* The fetch behind a variant change can outlast the observer's
       debounce on a slow connection, so sweep again afterwards. */
    document.addEventListener('change', function () {
      [200, 700, 1500].forEach(function (ms) { setTimeout(sync, ms); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
